(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-faq-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const faqItems = document.querySelectorAll('.faq-item-unique');

  faqItems.forEach(item => {
    item.addEventListener('click', function() {
      faqItems.forEach(i => {
        if (i !== item) {
          i.classList.remove('active');
          const answerEl = i.querySelector('.faq-answer-unique');
          if (answerEl) answerEl.classList.remove('show');
        }
      });

      const answer = item.querySelector('.faq-answer-unique');
      const isOpen = answer && answer.classList.contains('show');

      if (isOpen) {
        answer.classList.remove('show');
        item.classList.remove('active');
      } else {
        if (answer) answer.classList.add('show');
        item.classList.add('active');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
